import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import UserDateTimezoneFormat from '../../../../../components/user-date-timezone-format';
import { InvoicesContext } from '../../invoices-context';
import { messages } from '../../messages';
import style from '../../style.module.less';

const InvoiceDateColumn = ({ invoiceId }) => {
  const { invoices } = useContext(InvoicesContext);
  return (
    <div className={style['item-cell']}>
      <UserDateTimezoneFormat dateTime={invoices[invoiceId]?.createDateTimeUtc} />
    </div>
  );
};

InvoiceDateColumn.propTypes = {
  invoiceId: PropTypes.string.isRequired,
};

export default {
  getMessageDescriptor: () => <FormattedMessage {...messages.invoiceDate} />,
  id: 'invoiceDate',
  render: InvoiceDateColumn,
};
